// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"8e399a5e","573":"fec95aa1"}[chunkId] + ".chunk.css";
};